var map = {
	"./Action.jpg": 897,
	"./Adventure.jpg": 114,
	"./Animation.jpg": 56,
	"./Comedy.jpg": 988,
	"./Crime.jpg": 849,
	"./Documentary.jpg": 636,
	"./Drama.jpg": 829,
	"./Family.jpg": 656,
	"./Fantasy.jpg": 549,
	"./History.jpg": 459,
	"./Horror.jpg": 518,
	"./Music.jpg": 805,
	"./Mystery.jpg": 647,
	"./Romance.jpg": 830,
	"./Science_Fiction.jpg": 460,
	"./TV_Movie.jpg": 158,
	"./Thriller.jpg": 537,
	"./War.jpg": 520,
	"./Western.jpg": 61
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;